import { cn } from '@/lib/cn';

export interface BonusProgressProps {
  /** e.g. `₺310 / ₺500` */
  amounts: string;
  /** 0–100 */
  percent: number;
  size?: 'compact' | 'large';
  className?: string;
}

/**
 * Linear wagering progress (Figma BonusProgress).
 * Compact for list rows; large for details.
 */
export function BonusProgress({
  amounts,
  percent,
  size = 'compact',
  className,
}: BonusProgressProps) {
  const clamped = Math.max(0, Math.min(100, percent));
  const isLarge = size === 'large';

  return (
    <div className={cn('flex w-full flex-col gap-2', className)}>
      <div className="flex w-full items-center justify-between gap-2">
        <p
          className={cn(
            'text-text-secondary',
            isLarge ? 'text-[13px] font-medium' : 'text-[11px] font-medium',
          )}
        >
          {amounts}
        </p>
        <p
          className={cn(
            'shrink-0 text-right font-bold text-text-primary',
            isLarge ? 'text-[16px]' : 'text-[12px]',
          )}
        >
          {`${clamped}%`}
        </p>
      </div>
      <div
        className={cn(
          'w-full overflow-hidden rounded-full bg-bg-elevated',
          isLarge ? 'h-2.5' : 'h-1.5',
        )}
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="h-full rounded-full bg-[#e8a817] transition-[width] duration-300"
          style={{ width: `${clamped}%` }}
        />
      </div>
    </div>
  );
}
